import React from "react";

export const TermsOfUse = () => (
  <div
    style={{
      padding: "20px",
      maxWidth: "800px",
      margin: "auto",
      color: "white",
    }}
  >
    <h1>Terms of Use</h1>
    <p>
      <strong>Effective Date:</strong> 11/3/2024
    </p>
    <p>
      Please read these Terms of Use ("Terms") carefully before using the Avoid
      Scams application ("App") operated by Avoid Scams ("we" or "our"). By
      accessing or using the App, you agree to be bound by these Terms. If you
      do not agree with any part of these Terms, you may not use the App.
    </p>

    <h2>Use of the App</h2>
    <ul>
      <li>
        (a) The App is designed to simulate scams in order to help users become
        more aware of common fraud tactics and protect themselves against
        potential scams.
      </li>
      <li>
        (b) You must be at least 18 years old to use the App. If you are under
        18, you may only use the App with the consent and supervision of a
        parent or guardian.
      </li>
      <li>
        (c) You agree to use the App only for lawful purposes and in accordance
        with these Terms and any applicable laws or regulations.
      </li>
    </ul>

    <h2>User Accounts</h2>
    <ul>
      <li>
        (a) To access certain features of the App, you may be required to create
        a user account. You are responsible for maintaining the confidentiality
        of your account credentials and for all activities that occur under your
        account.
      </li>
      <li>
        (b) You agree to provide accurate and up-to-date information when
        creating your account.
      </li>
      <li>
        (c) We reserve the right to suspend or terminate your account if we
        suspect any unauthorized use or violation of these Terms.
      </li>
    </ul>

    <h2>Intellectual Property Rights</h2>
    <ul>
      <li>
        (a) The App and its original content, features, and functionality are
        owned by Avoid Scams and are protected by international copyright,
        trademark, patent, trade secret, and other intellectual property or
        proprietary rights laws.
      </li>
      <li>
        (b) You may not modify, reproduce, distribute, create derivative works,
        or publicly display or perform any part of the App without our prior
        written consent.
      </li>
    </ul>

    <h2>User Content</h2>
    <ul>
      <li>
        (a) By using the App, you may have the opportunity to submit or upload
        content, including but not limited to text, images, and feedback ("User
        Content").
      </li>
      <li>
        (b) You retain ownership of any User Content that you submit or upload,
        but you grant us a worldwide, non-exclusive, royalty-free, perpetual,
        irrevocable, and sublicensable license to use, reproduce, modify, adapt,
        publish, translate, distribute, perform, and display such User Content
        for the purposes of operating and improving the App.
      </li>
      <li>
        (c) You are solely responsible for the User Content you submit or
        upload, and you represent and warrant that you have all necessary rights
        to grant the license described above.
      </li>
    </ul>

    <h2>Prohibited Conduct</h2>
    <ul>
      <li>
        (a) You agree not to engage in any of the following activities in
        connection with the App:
      </li>
      <ul>
        <li>Violating any applicable laws or regulations.</li>
        <li>
          Interfering with or disrupting the App or the servers or networks
          connected to the App.
        </li>
        <li>
          Uploading or transmitting any viruses, worms, or other malicious code.
        </li>
        <li>
          Attempting to gain unauthorized access to any portion of the App or
          any other user accounts.
        </li>
        <li>
          Collecting or storing personal information of other users without
          their consent.
        </li>
        <li>
          Engaging in any conduct that could damage, disable, overburden, or
          impair the App or interfere with any other party's use of the App.
        </li>
      </ul>
      <li>
        (b) We reserve the right to suspend or terminate your access to the App
        for any violation of these Terms or for any other reason at our sole
        discretion.
      </li>
    </ul>

    <h2>Disclaimer of Warranty</h2>
    <ul>
      <li>
        (a) The App is provided on an "as is" and "as available" basis. We make
        no warranties, expressed or implied, regarding the accuracy,
        reliability, or availability of the App.
      </li>
      <li>
        (b) We do not guarantee that the App will be error-free, uninterrupted,
        or free of viruses or other harmful components.
      </li>
      <li>
        (c) Your use of the App is at your sole risk, and you assume all
        responsibility for any loss or damage resulting from such use.
      </li>
    </ul>

    <h2>Limitation of Liability</h2>
    <ul>
      <li>
        (a) To the maximum extent permitted by applicable law, in no event shall
        Avoid Scams or its directors, employees, partners, or affiliates be
        liable for any indirect, incidental, consequential, or punitive damages
        arising out of or related to your use of the App.
      </li>
      <li>
        (b) In no event shall our total liability for all claims, damages, or
        losses exceed the amount paid by you, if any, for accessing or using the
        App during the six months prior to the claim or cause of action.
      </li>
    </ul>

    <h2>Governing Law and Jurisdiction</h2>
    <ul>
      <li>
        (a) These Terms shall be governed by and construed in accordance with
        the laws of [Insert jurisdiction].
      </li>
      <li>
        (b) Any dispute arising out of or relating to these Terms or the use of
        the App shall be subject to the exclusive jurisdiction of the courts
        located in [Insert jurisdiction].
      </li>
    </ul>

    <h2>Changes to the Terms</h2>
    <p>
      We reserve the right to modify or replace these Terms at any time. The
      most current version of the Terms will be posted on the App. By continuing
      to access or use the App after any revisions become effective, you agree
      to be bound by the revised Terms.
    </p>

    <h2>Contact Us</h2>
    <p>
      If you have any questions or concerns about these Terms, please contact us
      at{" "}
      <a href="mailto:aifutureapps@gmail.com" style={{ color: "white" }}>
        aifutureapps@gmail.com
      </a>
      .
    </p>
  </div>
);
